import { createPlugin } from '@front/utils/alpine';
export default createPlugin((vm) => {
    vm.directive('obfuscated-link', (el, { modifiers, expression }) => {
        const htmlEl = el;
        const link = document.createElement('a');
        try {
            link.setAttribute('href', modifiers.includes('encrypted') ? atob(expression) : expression);
        }
        catch (e) {
            console.error(e);
        }
        let attribute;
        const attributes = Array.from(htmlEl.attributes);
        while ((attribute = attributes.pop())) {
            if (attribute.nodeName.startsWith('x-obfuscated-link')) {
                continue;
            }
            link.setAttribute(attribute.nodeName, attribute.nodeValue || '');
        }
        link.innerHTML = htmlEl.innerHTML;
        htmlEl?.parentNode?.replaceChild(link, htmlEl);
    });
});
